// myapp/src/api/subscriptionInterceptor.ts
import { AxiosInstance, AxiosError } from "axios";

let isSubscriptionModalOpen = false;
let failedRequestsQueue: Array<{
  config: any;
  resolve: (value: any) => void;
  reject: (reason: any) => void;
  apiInstance: AxiosInstance;
  tokenKey: string;
}> = [];

if (typeof window !== "undefined") {
  // Listen for the custom renewal event to retry all queued requests
  window.addEventListener("subscription-renewed", async () => {
    const queue = [...failedRequestsQueue];
    failedRequestsQueue = [];
    isSubscriptionModalOpen = false;

    for (const req of queue) {
      try {
        const token = localStorage.getItem(req.tokenKey);
        if (token) {
          req.config.headers = req.config.headers || {};
          req.config.headers.Authorization = `Bearer ${token}`;
        }
        const response = await req.apiInstance(req.config);
        req.resolve(response);
      } catch (retryError) {
        req.reject(retryError);
      }
    }
  });

  // Listen for cancellation or logouts to clean up the queue
  window.addEventListener("subscription-renewal-cancelled", () => {
    const queue = [...failedRequestsQueue];
    failedRequestsQueue = [];
    isSubscriptionModalOpen = false;

    for (const req of queue) {
      req.reject(new Error("Subscription renewal cancelled."));
    }
  });
}

export const handleSubscriptionError = (
  error: AxiosError,
  apiInstance: AxiosInstance,
  tokenKey: string
) => {
  if (error.response && error.response.status === 402) {
    const originalRequest = error.config;
    if (!originalRequest) return Promise.reject(error);

    const retryPromise = new Promise((resolve, reject) => {
      failedRequestsQueue.push({
        config: originalRequest,
        resolve,
        reject,
        apiInstance,
        tokenKey
      });
    });

    if (!isSubscriptionModalOpen) {
      isSubscriptionModalOpen = true;

      const errorData = error.response.data as any;
      const detailMessage = errorData?.detail || errorData?.message || "Your workspace subscription has expired. Please renew your billing plan to reactivate services.";
      
      // Dispatch global window event to show Subscription Renewal Modal
      window.dispatchEvent(
        new CustomEvent("subscription-expired", {
          detail: {
            title: errorData?.title || "Subscription Expired",
            detail: detailMessage,
            status: 402
          }
        })
      );
    }

    return retryPromise;
  }

  return Promise.reject(error);
};
